module.exports = [{"name":"网上流向查询","url":"#","subMenu":[{"name":"销售流向查询","url":"/manage/sales"},{"name":"库存数据查询","url":"/manage/warehouse"},{"name":"采购流向查询","url":"/manage/purchase"}]},{"name":"用户管理","url":"#","subMenu":[{"name":"用户管理","url":"/manage/user"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/menus/admin_menu.json
// module id = 1733
// module chunks = 2